import { SubathonConfigCard } from "@/cards/SubathonConfigCard";
import { SimpleSubathonWidget } from "@/Components/SimpleSubathonWidget/SimpleSubathonWidget";
import { useSocket } from "@/hooks/useSocket";
import { SubathonDocument, UpdateSubathonEvent } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const SubathonPage: FC = () => {
    const { id } = useParams();
    const socket = useSocket();
    const [subathon, setSubathon] = useState<SubathonDocument | null>(null);

    useEffect(() => {
        socket.emit("get-subathons", s => {
            const foo = s.find(bar => bar._id === id);
            if (foo) {
                setSubathon(foo);
            }
        });

        const onUpdateSubathon = (e: UpdateSubathonEvent) => {
            if (e.subathon._id === id) {
                setSubathon(e.subathon);
            }
        }

        socket.on("update-subathon", onUpdateSubathon);

        return () => {
            socket.off("update-subathon", onUpdateSubathon);
        }
    }, [id, socket]);

    const setField = <F extends keyof SubathonDocument>(field: F, value: SubathonDocument[F]) => {
        setSubathon((prev) => {
            return {
                ...prev,
                [field]: value
            } as SubathonDocument;
        });
    };

    const doSave = useCallback(() => {
        if (!subathon) return;
        socket.emit("update-subathon", subathon._id, subathon);
    }, [socket, subathon]);

    const doStart = useCallback(() => {
        if (!subathon) return;
        socket.emit("start-subathon", subathon._id);
    }, [socket, subathon]);

    const doPause = useCallback(() => {
        if (!subathon) return;
        socket.emit("pause-subathon", subathon._id);
    }, [socket, subathon]);

    const doReset = useCallback(() => {
        if (!subathon) return;
        const confirmed = confirm("Are you sure you want to reset the subathon? This will reset all timers and progress.");
        if (!confirmed) return;
        
        socket.emit("reset-subathon", subathon._id);
    }, [socket, subathon]);

    if (!subathon) {
        return null;
    }

    return (
        <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12">
                <div className="flex flex-row justify-center min-w-3xl max-w-max m-auto">
                    <SimpleSubathonWidget subathon={subathon}/>
                </div>
            </div>
            <SubathonConfigCard subathon={subathon} setField={setField} doSave={doSave} doStart={doStart} doPause={doPause} doReset={doReset} />
        </div>
    )
}